import { breakpoints } from '@/utils/util-breakpoints';
import { GlobalToken } from 'antd';
import styled from 'styled-components';

export const TankSectionContainer = styled.div<{ theme: { token: GlobalToken } }>`
  width: 100%;
  padding: 16px 0;
  border-bottom: 1px solid ${({ theme }) => theme.token.colorTextQuaternary};

  @media (max-width: ${breakpoints.md - 1}px) {
    padding: 0;
  }

  .tank-section-header {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 100%;
    gap: 16px;

    @media (max-width: ${breakpoints.md - 1}px) {
      flex-direction: column;
      gap: 16px;
    }
  }

  .tank-section-title {
    color: ${({ theme }) => theme.token.colorText};
    font-size: ${({ theme }) => theme.token.fontSizeLG}px;
    font-weight: 600;
    line-height: 24px;
    white-space: nowrap;
    flex-shrink: 0;

    @media (max-width: ${breakpoints.md - 1}px) {
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.token.colorTextSecondary};
      margin-bottom: 8px;
    }
  }

  .tank-list-container {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .tank-controls {
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 16px;

    &.auto-width {
      width: auto;
    }

    &.full-width {
      width: 100%;
    }

    @media (max-width: ${breakpoints.md - 1}px) {
      width: 100%;
      flex-wrap: wrap;
      gap: 16px;
      justify-content: flex-start;
      padding: 0;
      .tank-form-item-pressure {
        width: 260px;
      }

      .tank-form-item {
        width: 100%;
        margin: 0;

        .ant-form-item-control-input {
          width: 100%;
        }
      }
    }
  }

  .tank-select {
    min-width: 7.1875rem;
    height: 2.5rem;
    background: transparent;
    border-radius: ${({ theme }) => theme.token.borderRadiusLG}px;
    outline: 1px ${({ theme }) => theme.token.colorTextQuaternary} solid;
    outline-offset: -1px;
    border: none;

    @media (max-width: ${breakpoints.md - 1}px) {
      width: 100%;

      &.ant-select {
        width: 100%;
      }

      .ant-select-selector {
        width: 100%;
      }
    }
  }

  .tank-action-group {
    display: flex;
    gap: 16px;
    align-items: center;

    @media (max-width: ${breakpoints.md - 1}px) {
      width: 100%;
    }

    .add-tank-button {
      width: 40px;
      height: 40px;
      padding: 0;
      background: transparent;
      border-radius: ${({ theme }) => theme.token.borderRadiusLG}px;
      outline: 1px ${({ theme }) => theme.token.colorTextQuaternary} solid;
      outline-offset: -1px;
      border: none;
    }
  }

  .tank-capacity-input-group {
    display: flex;

    @media (max-width: ${breakpoints.md - 1}px) {
      flex: 1;
    }
  }

  .tank-content-section {
    flex: 1;
    display: flex;
    flex-direction: column;

    @media (max-width: ${breakpoints.md - 1}px) {
      width: 100%;
      padding: 0;
    }
  }

  .tank-capacity-input {
    width: 64px;
    height: 40px;
    background: transparent;
    border-top-left-radius: ${({ theme }) => theme.token.borderRadiusLG}px;
    border-bottom-left-radius: ${({ theme }) => theme.token.borderRadiusLG}px;
    outline: 1px ${({ theme }) => theme.token.colorTextQuaternary} solid;
    outline-offset: -1px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .ant-input,
    .ant-input-number {
      width: 100%;
      height: 100%;
      border: none;
      background: transparent;
      text-align: center;
      padding: 0;
      color: ${({ theme }) => theme.token.colorText};
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .input-number-centered {
      display: flex;
      align-items: center;
      height: 100%;
    }

    .ant-input-number-input {
      text-align: center;
      height: 100%;
      padding: 0;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 40px;
    }

    .ant-input-number-input-wrap {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }

    .ant-input-number-input-wrap input {
      line-height: normal;
      vertical-align: middle;
      text-align: center;
      width: 100%;
      height: 100%;
    }

    @media (max-width: ${breakpoints.sm - 96}px) {
      flex: 1;
    }
  }

  .hidden-controls-input-number {
    &.ant-input-number {
      .ant-input-number-handler-wrap {
        display: none;
      }
    }
  }

  .capacity-unit {
    height: 40px;
    padding: 0 12px;
    background: ${({ theme }) => theme.token.colorFillQuaternary};
    border-top-right-radius: ${({ theme }) => theme.token.borderRadiusLG}px;
    border-bottom-right-radius: ${({ theme }) => theme.token.borderRadiusLG}px;
    outline: 1px ${({ theme }) => theme.token.colorTextQuaternary} solid;
    outline-offset: -1px;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.token.colorText};
    font-size: ${({ theme }) => theme.token.fontSize}px;
    font-family: ${({ theme }) => theme.token.fontFamily};
    font-weight: 400;
  }

  .tank-action-button {
    width: 40px;
    height: 40px;
    padding: 0;
    background: transparent;
    border-radius: ${({ theme }) => theme.token.borderRadiusLG}px;
    outline: 1px ${({ theme }) => theme.token.colorTextQuaternary} solid;
    outline-offset: -1px;
    border: none;
  }
`;
